import { proxied } from "@/lib/api";


const Anniversary = ({ settings = {} }) => (
  <section className="bg-[#F3EBE1] py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-14 items-center">
      <div className="md:col-span-3">
        <div className="text-[#8B2323] text-xs md:text-sm tracking-[0.5em] uppercase mb-3">{settings.anniversary_kicker || "Silver Jubilee"}</div>
        <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#2D2825]">
          {settings.anniversary_title || "25 Years of Rudralife"}
        </h2>
        <p className="mt-6 text-[#5C544F] text-sm md:text-base leading-relaxed">
          {settings.anniversary_body}
        </p>

        <div className="mt-8 grid grid-cols-3 gap-4">
          {[
            { n: settings.stat_seekers || "5,00,000+", l: "Seekers" },
            { n: settings.stat_exhibitions || "1,200+", l: "Exhibitions" },
            { n: settings.stat_years || "25+", l: "Years" },
          ].map((s) => (
            <div key={s.l} className="text-center border border-[#D4AF37]/30 rounded-2xl bg-white py-4 md:py-5">
              <div className="font-serif text-2xl md:text-3xl text-[#8B2323]">{s.n}</div>
              <div className="text-[9px] md:text-[10px] tracking-[0.3em] uppercase text-[#5C544F] mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="md:col-span-2 grid grid-cols-2 gap-3 md:gap-4">
        <div className="aspect-square rounded-2xl overflow-hidden bg-white">
          <img src={proxied(settings.anniversary_image_1)} alt="Rudralife 25 years" className="w-full h-full object-cover" />
        </div>
        <div className="aspect-square rounded-2xl overflow-hidden bg-white mt-6 md:mt-10">
          <img src={proxied(settings.anniversary_image_2)} alt="Rudralife legacy" className="w-full h-full object-cover" />
        </div>
      </div>
    </div>
  </section>
);

export default Anniversary;
